import { Component } from "@angular/core";

@Component({
    selector: 'app-subfolders-details-banner-error',
    templateUrl: './subfolders-details-banner-error.component.html',
    styleUrls: ['./subfolders-details-banner-error.component.scss']
})
export class SubfoldersDetailsBannerErrorComponent {
    
}